import { useEffect, useState } from "react";
import ButtonComponent from "../../../../../../app/common-components/ButtonComponent";
import Input from "../../../../../../app/common-components/form/input";
import styles from "./CisBenchmarkFirstSeenPopup.module.scss";

const CisBenchmarkFirstSeenConfigPopup = ({
    isOpen,
    onClose,
    onSave,
    initialData,
    isLoading,
}) => {
    const [formState, setFormState] = useState({
        overdueBasedOn: "First Seen Date",
        showFirstSeenDate: false,
        showFirstLoggedDate: false,
        firstLoggedRule: "-",
    });

    useEffect(() => {
        if (initialData) {
            setFormState((prev) => ({
                ...prev,
                overdueBasedOn: initialData.overdueBasedOn || "First Seen Date",
                firstLoggedRule: initialData.firstLoggedRule || "-",
                showFirstSeenDate: initialData.showFirstSeenDate ?? false,
                showFirstLoggedDate: initialData.showFirstLoggedDate ?? false,
            }));
        } else {

            setFormState({
                overdueBasedOn: "First Seen Date",
                showFirstSeenDate: false,
                showFirstLoggedDate: false,
                firstLoggedRule: "-",
            });
        }
    }, [initialData]);

    const buildSavePayload = () => {
        const payload = {
            overdueBasedOn: formState.overdueBasedOn || "First Seen Date",
            showFirstSeenDate: formState.overdueBasedOn === "First Seen Date",
            showFirstLoggedDate: false,
        };

        if (formState.overdueBasedOn === "First Logged Date") {
            payload.showFirstSeenDate = Boolean(formState.showFirstSeenDate);
            payload.showFirstLoggedDate = Boolean(formState.showFirstLoggedDate);
            payload.firstLoggedRule = "Next month start";
        }

        return payload;
    };

    if (!isOpen) return null;

    return (
        <div className={styles["popup-overlay"]}>
            <div className={styles["popup-container"]}>
                <div className={`${styles["popup-header"]} d-flex align-items-center justify-content-between`}>
                    <h1 className={styles["popup-title"]}>CIS Benchmark First Seen Configuration</h1>
                    <button className={styles["popup-close"]} aria-label="Close" onClick={onClose}>
                        &times;
                    </button>
                </div>

                <div className={styles["popup-divider"]} />

                <h4 className={styles["section-title"]}>Overdue Calculation Based On</h4>

                <div className={`${styles["radio-card-group"]} d-flex gap-3`} data-testid="overdueBasedOnRadioGroup">
                    <label
                        className={`${styles["radio-card"]} ${formState.overdueBasedOn === "First Seen Date" ? styles["active"] : ""
                            }`}
                        data-testid="firstSeenDateRadio"
                        onClick={() =>
                            setFormState((s) => ({
                                ...s,
                                overdueBasedOn: "First Seen Date",
                            }))
                        }
                    >
                        <Input
                            type="radio"
                            name="overdueBasedOn"
                            checked={formState.overdueBasedOn === "First Seen Date"}
                            onChange={() => { }} />
                        <span>First Seen Date</span>
                    </label>

                    <label
                        className={`${styles["radio-card"]} ${formState.overdueBasedOn === "First Logged Date" ? styles["active"] : ""
                            }`}
                        data-testid="firstLoggedDateRadio"
                        onClick={() =>
                            setFormState((s) => ({
                                ...s,
                                overdueBasedOn: "First Logged Date",
                                showFirstLoggedDate: true,
                            }))
                        }
                    >
                        <Input
                            type="radio"
                            name="overdueBasedOn"
                            checked={formState.overdueBasedOn === "First Logged Date"}
                            onChange={() => { }}
                        />
                        <span>First Logged Date</span>
                    </label>
                </div>

                {formState.overdueBasedOn === "First Logged Date" && (
                    <>
                        {/* First Logged Date Calculation Rule */}
                        <h4 className={`${styles["section-title"]} mt-24`}>
                            First Logged Date Calculation Rule
                        </h4>

                        <div className={styles["readonly-field"]}>
                            First day of next month
                        </div>

                        {/* Column Display Section */}
                        <h4 className={`${styles["section-title"]}`}>
                            Column Display in CIS Benchmark Details Table
                        </h4>

                        <div className={`${styles["checkbox-group"]} d-flex flex-column gap-2`}>
                            <label className={styles["check-label-disabled"]}>
                                <Input
                                    type="checkbox"
                                    checked={true}
                                    onChange={() => { }}
                                />
                                <span className={styles["check-text"]}>Show First Logged Date</span>
                            </label>

                            <label className={styles["check-label"]}>
                                <Input
                                    type="checkbox"
                                    checked={formState.showFirstSeenDate}
                                    onChange={() =>
                                        setFormState((s) => ({
                                            ...s,
                                            showFirstSeenDate: !s.showFirstSeenDate,
                                        }))
                                    }
                                />
                                <span className={styles["check-text"]}>Show First Seen Date</span>
                            </label>
                        </div>
                    </>
                )}


                <div className={`${styles["popup-footer"]} d-flex justify-content-end gap-1 mt-3`}>
                    <ButtonComponent
                        text="Cancel"
                        onClick={onClose}
                        className="cancelBtnStyle btn btn-primary"
                        data-testid="cancelButton"
                    />
                    <ButtonComponent
                        text="Save"
                        onClick={() => onSave(buildSavePayload())}
                        className="btnStyle btn btn-primary"
                        data-testid="saveButton"
                        disabled={isLoading}
                    />

                </div>
            </div>
        </div>
    );
};

export default CisBenchmarkFirstSeenConfigPopup;
